<template>
  <div class="content_list">
    <div class="list_item" v-for="(item,index) in businessList" :key="index">
      <div class="_box_top">
        <div class="title_picture">
          <img :src="item.avatar_image" alt=""/>
          <img v-if="item.exhibitor_long_id" src="@/assets/authentication.png" alt=""/>
        </div>
        <div>
          <div class="title_name">
            <div>{{ item.name }}</div>
            <div>{{ item.duty }}</div>
          </div>
          <div class="company">{{ item.company }}</div>
        </div>
        <!--        <img class="edit_img" src="@/assets/edit.png" alt=""/>-->
      </div>
      <div class="tag">{{ langSet == 'cn' ? item.product_category : item.product_category_en }}</div>
      <div class="synopsis">
        {{ langSet == 'cn' ? item.requirement : item.requirement }}
      </div>
      <!--      <div class="img_box">-->
      <!--        <img class="show_image" v-for="(img_item,img_index) in item.image" :key="img_index" :src="img_item" alt=""/>-->
      <!--      </div>-->
      <div class="line"></div>
      <div class="text_box">
        <div class="item_text margin_bottom">{{ item.create_time }}</div>
        <div class="see_button" @click="item_click(item)">{{ langSet == 'cn' ? '查看详情' : 'View details' }}</div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "business_list",
  props: ['businessList', 'external'],
  data() {
    return {
    }
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    item_click(item) {
      if (this.external) {
        this.$emit("item_click", item, this.external);
      } else {
        this.$emit("item_click", item);
      }
    },
  },
}
</script>


<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;

  .list_item {
    width: calc((100% - 80px) / 3);
    height: 357px;
    padding: 20px;
    box-sizing: border-box;
    background: #f7f8fa;
    margin: 0 40px 40px 0;
    //font-size: 18px;
    //color: #757575;
    line-height: 25px;
    cursor: pointer;

    &:hover {
      border: 1px solid #004190;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }


    ._box_top {
      position: relative;
      display: flex;
      padding: 0 10px;
      align-items: center;
      border-radius: 8px;

      .title_picture {
        position: relative;
        margin-right: 10px;
      }

      .title_picture > img:first-child {
        width: 65px;
        height: 65px;
        border-radius: 50%;
      }

      .title_picture > img:nth-child(2) {
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .title_name {
        display: flex;
        margin-bottom: 5px;
        align-items: center;
      }

      .title_name > div:nth-child(1) {
        font-weight: 600;
        font-size: 18px;
        //color: #FFFFFF;
        line-height: 25px;
        letter-spacing: 1px;
        text-align: center;
        font-style: normal;
      }

      .title_name > div:nth-child(2) {
        margin-left: 10px;
        font-weight: 400;
        font-size: 15px;
        //color: #FFFFFF;
        line-height: 21px;
        text-align: center;
        font-style: normal;
      }

      .company {
        font-weight: 400;
        font-size: 15px;
        //color: #FFFFFF;
        line-height: 21px;
        text-align: left;
        font-style: normal;
      }
    }

    .tag {
      display: inline-block;
      //width: 66px;
      //height: 20px;
      background: #F8E4E8;
      border-radius: 3px;
      color: #E62344;
      padding: 0 10px;
      font-weight: 400;
      font-size: 11px;

      //display: flex;
      //justify-content: center;
      //align-items: center;
      margin: 15px 0;
    }

    .synopsis {
      font-weight: 400;
      font-size: 16px;
      color: #555555;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      height: 96px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }

    .img_box {
      display: flex;
      justify-content: center;
      align-items: center;

      .show_image {
        width: 100px;
        height: 100px;
      }
    }

    .line {
      border-top: 2px dashed #DDDDDD; /* 2px 红色虚线 */
      margin: 16px 0 10px 0;
    }

    .text_box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .see_button {
        width: 124px;
        height: 40px;
        background: #004190;
        border-radius: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .item_text {
        color: #888888;
        font-size: 14px;
      }
    }
  }

}


@media only screen and (max-width: 767px) {
  .content_list {
    display: flex;

    .list_item {
      width: 100%;
      height: 6.1rem;
      background: #F7F8FA;
      margin: 0 0 0.38rem 0;

      .synopsis {
        height: 1.85rem;
        font-weight: 400;
        font-size: 0.31rem;
        color: #555555;
        line-height: 0.46rem;
        text-align: left;
        font-style: normal;
      }

      ._box_top {


        .company {
          text-align: left;
          font-weight: 400;
          font-size: 0.29rem;
          color: #7A7E93;
          line-height: 0.4rem;
          font-style: normal;
        }

      }

      .tag {
        font-size: 0.21rem;
        font-style: normal;
        height: 0.38rem;
        line-height: 0.38rem;
        border-radius: 0.06rem;
        margin: 0.29rem 0;
        padding: 0.04rem 0.19rem;
      }
    }

  }


}


</style>